import React from 'react';

const ProductivityRoadmap = ({ sampleDataFallback }) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold text-slate-800 dark:text-white">
        🗺️ Productivity Enhancement Roadmap
      </h2>
      <span className="bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1 rounded-full text-sm font-medium">
        Premium Feature
      </span>
    </div>

    <div className="space-y-6">
      {/* Quick Wins */}
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-green-800 dark:text-green-300">
            ⚡ Quick Wins ({sampleDataFallback.productivityRoadmap.quickWins.timeframe})
          </h3>
          <div className="text-right">
            <p className="text-2xl font-bold text-green-700 dark:text-green-400">
              +{sampleDataFallback.productivityRoadmap.quickWins.productivityGain}%
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              productivity improvement
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {sampleDataFallback.productivityRoadmap.quickWins.examples.map(
            (example, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-700 p-3 rounded border border-green-100 dark:border-green-700"
              >
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {example}
                </p>
              </div>
            )
          )}
        </div>

        <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400">
          <span>
            Range: {sampleDataFallback.productivityRoadmap.quickWins.range}
          </span>
          <span>
            Success Rate:{' '}
            {sampleDataFallback.productivityRoadmap.quickWins.successRate}% of
            facilities
          </span>
        </div>
      </div>

      {/* Medium Term */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-blue-800 dark:text-blue-300">
            🔧 Medium Term (
            {sampleDataFallback.productivityRoadmap.mediumTerm.timeframe})
          </h3>
          <div className="text-right">
            <p className="text-2xl font-bold text-blue-700 dark:text-blue-400">
              +{sampleDataFallback.productivityRoadmap.mediumTerm.productivityGain}%
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              productivity improvement
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {sampleDataFallback.productivityRoadmap.mediumTerm.examples.map(
            (example, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-700 p-3 rounded border border-blue-100 dark:border-blue-700"
              >
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {example}
                </p>
              </div>
            )
          )}
        </div>

        <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400">
          <span>
            Range: {sampleDataFallback.productivityRoadmap.mediumTerm.range}
          </span>
          <span>
            Success Rate:{' '}
            {sampleDataFallback.productivityRoadmap.mediumTerm.successRate}% of
            facilities
          </span>
        </div>
      </div>

      {/* Long Term */}
      <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-700 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-purple-800 dark:text-purple-300">
            🎯 Long Term (
            {sampleDataFallback.productivityRoadmap.longTerm.timeframe})
          </h3>
          <div className="text-right">
            <p className="text-2xl font-bold text-purple-700 dark:text-purple-400">
              +{sampleDataFallback.productivityRoadmap.longTerm.productivityGain}%
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              productivity improvement
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {sampleDataFallback.productivityRoadmap.longTerm.examples.map(
            (example, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-700 p-3 rounded border border-purple-100 dark:border-purple-700"
              >
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {example}
                </p>
              </div>
            )
          )}
        </div>

        <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400">
          <span>
            Range: {sampleDataFallback.productivityRoadmap.longTerm.range}
          </span>
          <span>
            Success Rate:{' '}
            {sampleDataFallback.productivityRoadmap.longTerm.successRate}% of
            facilities
          </span>
        </div>
      </div>
    </div>

    {/* Cumulative Impact */}
    <div className="bg-gradient-to-r from-emerald-500 to-blue-500 dark:from-emerald-600 dark:to-blue-600 text-white p-6 rounded-lg text-center">
      <h3 className="text-xl font-bold mb-2">🚀 Cumulative Impact</h3>
      <p className="text-4xl font-bold">
        +{sampleDataFallback.productivityRoadmap.cumulativeImpact.totalGain}%
      </p>
      <p className="text-lg">
        productivity improvement (Range:{' '}
        {sampleDataFallback.productivityRoadmap.cumulativeImpact.range})
      </p>
    </div>
  </div>
);

export default ProductivityRoadmap;


